import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Process } from "@/types/process";
import { useNavigate } from "react-router-dom";
import DocumentListItem from "@/components/documents/DocumentListItem";

interface ProcessDocumentsCardProps {
  process: Process;
  documents?: any[];
}

const ProcessDocumentsCard: React.FC<ProcessDocumentsCardProps> = ({
  process,
  documents,
}) => {
  const navigate = useNavigate();

  const handleAddDocument = () => {
    navigate("/documents/new", {
      state: { process },
    });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Documentos</CardTitle>
        <CardDescription>Documentos do processo</CardDescription>
      </CardHeader>
      <CardContent>
        {documents && documents.length > 0 ? (
          <div className="space-y-2">
            {documents.map((doc) => (
              <DocumentListItem
                key={doc.id}
                document={doc}
                onClick={() => navigate(`/documents/${doc.id}`)}
              />
            ))}
          </div>
        ) : (
          <p className="text-muted-foreground">Nenhum documento disponível</p>
        )}
      </CardContent>
      <CardFooter>
        <Button
          variant="outline"
          className="w-full"
          onClick={handleAddDocument}
        >
          Adicionar Documento
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ProcessDocumentsCard;
